export const environment = {
  production: true,
  apiUrl: 'https://dev-ssics-api.azurewebsites.net/api/',
  reportApiUrl: 'https://dev-ssics-reportapi.azurewebsites.net/api/',
  oktaUrl: '',
  // apiUrl: 'https://localhost:44393/api/',
};
